import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Arrow Circle Left Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M128 2.56c-96.564 0-156.916 104.533-108.634 188.16s168.986 83.627 217.268 0A125.44 125.44 0 0 0 253.44 128C253.367 58.752 197.248 2.633 128 2.56m0 231.582c-81.708.003-132.774-88.446-91.924-159.209C76.927 4.171 179.062 4.166 219.92 74.925A106.14 106.14 0 0 1 234.14 128c-.066 58.593-47.548 106.075-106.141 106.142M185.895 128c0 5.329-4.32 9.649-9.649 9.65h-73.201l22.133 22.12c5.255 5.255 2.85 14.229-4.328 16.153a9.65 9.65 0 0 1-9.326-2.5l-38.597-38.596c-3.773-3.77-3.773-9.885 0-13.654l38.597-38.597c5.255-5.255 14.229-2.85 16.152 4.328a9.65 9.65 0 0 1-2.498 9.326l-22.133 22.12h73.201c5.33.001 9.65 4.321 9.65 9.65" }, null, -1)
  ])))
}
export default { render: render }